<ng-container *vsLet="terms$ | async as terms">
  <ng-container *ngIf="terms && terms.length > 1">
    <vs-input-group class="p-1 border border-gray-200 gap-1 rounded-[10px] !bg-base">
      <ng-container *ngFor="let term of terms">
        <button
          *vsLet="selected === term.id as isSelected"
          vs-button
          size="lg"
          [theme]="isSelected ? 'primary' : 'default'"
          [appearance]="isSelected ? 'default' : 'clear'"
          [class]="isSelected ? '!text-xl' : '!text-lg !bg-themed-100 hover:!bg-themed-50'"
          (click)="selectTerm(term.id)"
        >
          {{ term.title }}
        </button>
      </ng-container>
    </vs-input-group>
  </ng-container>
</ng-container>
